module.exports = __webpack_public_path__ + "media/images/favicon-6c370e172f513b2931dfa6c40fc26d95.ico";